<template>
  <div>
    <v-card class="mx-auto mb-5 secondary rounded-0" elevation="0">
      <CardHeader
        title="DIN BRUGER"
        :icon="
          allowEditUsers
            ? !displayUser
              ? openDisplayIcon
              : closeDisplayIcon
            : null
        "
        @iconClicked="displayUser = !displayUser"
      />
      <div v-show="displayUser" class="sub-element-content">
        <v-row no-gutters>
          <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6">
            <v-row no-gutters>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 3">
                Navn:
              </v-col>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 8 : 9">
                {{ name }}
              </v-col>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 3">
                Virksomhed:
              </v-col>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 8 : 9">
                {{ companyName }}
              </v-col>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 3">
              </v-col>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 8 : 9">
                {{ companyAddress }}
              </v-col>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 3">
              </v-col>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 8 : 9">
                {{ companyZipCity }}
              </v-col>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 3">
              </v-col>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 8 : 9">
                {{ companyCountry }}
              </v-col>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 3">
                E-mail:
              </v-col>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 8 : 9">
                {{ email }}
              </v-col>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 3">
                Telefon:
              </v-col>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 8 : 9">
                {{ phone }}
              </v-col>
            </v-row>
          </v-col>
          <v-col
            :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6"
            align-self="end"
          >
            <v-card-actions>
              <v-spacer />
              <v-btn
                class="sub-element-button"
                @click="displayChangePassword = true"
              >
                SKIFT PASSWORD
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
        <ChangePasswordDialog
          :display="displayChangePassword"
          :user="loggedInUser"
          @disposeDialog="displayChangePassword = false"
        />
      </div>
    </v-card>
  </div>
</template>

<script>
import { dictionary } from "../helpers";
import ChangePasswordDialog from "@/components/dialogs/ChangePasswordDialog.vue";
import CardHeader from "@/components/templates/CardHeader.vue";

export default {
  name: "LoggedInUser",
  components: {
    ChangePasswordDialog,
    CardHeader
  },
  created() {
    this.allowEditUsers = this.$store.getters["user/allowEditUsers"];
  },
  data() {
    return {
      allowEditUsers: true,
      displayUser: true,
      openDisplayIcon: dictionary.mdi.open,
      closeDisplayIcon: dictionary.mdi.close,
      displayChangePassword: false
    };
  },
  computed: {
    loggedInUser() {
      return this.$store.state.user.activeUser
        ? this.$store.state.user.activeUser
        : {};
    },
    name() {
      return this.$store.state.user.activeUser
        ? this.$store.state.user.activeUser.first_name +
            " " +
            this.$store.state.user.activeUser.last_name
        : "";
    },
    companyName() {
      return this.$store.state.user.activeUser &&
        this.$store.state.user.activeUser.company
        ? this.$store.state.user.activeUser.company.name
        : "";
    },
    companyAddress() {
      return this.$store.state.user.activeUser &&
        this.$store.state.user.activeUser.company
        ? this.$store.state.user.activeUser.company.address
        : "";
    },
    companyZipCity() {
      return this.$store.state.user.activeUser &&
        this.$store.state.user.activeUser.company
        ? this.$store.state.user.activeUser.company.zip +
            " " +
            this.$store.state.user.activeUser.company.city
        : "";
    },
    companyCountry() {
      return this.$store.state.user.activeUser &&
        this.$store.state.user.activeUser.company
        ? this.$store.state.user.activeUser.company.country
        : "";
    },
    email() {
      return this.$store.state.user.activeUser
        ? this.$store.state.user.activeUser.email
        : "";
    },
    phone() {
      return this.$store.state.user.activeUser
        ? this.$store.state.user.activeUser.phone
        : "";
    }
  }
};
</script>
